import React from "react";

export const HelenaWordmark = () => {
  return (
    <>
      <svg
        width="49"
        height="12"
        viewBox="0 0 49 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3368 11.8117H7.84739V6.83493H2.4894V11.8117H0V0H2.4894V4.79673H7.84739V0H10.3368V11.8117Z"
          fill="url(#paint0_linear_3526_87111)"
        />
        <path
          d="M15.3987 4.61664C14.3436 4.61664 13.5852 5.41064 13.5028 6.5075H17.2534C17.2039 5.38608 16.4703 4.61664 15.3987 4.61664ZM17.2863 9.12688H19.4955C19.2317 10.8458 17.649 12 15.4646 12C12.7444 12 11.1123 10.2729 11.1123 7.46521C11.1123 4.66576 12.7609 2.84857 15.374 2.84857C17.9458 2.84857 19.5697 4.57572 19.5697 7.2442V7.97271H13.4781V8.12005C13.4781 9.37244 14.2776 10.2319 15.5058 10.2319C16.3878 10.2319 17.0638 9.79809 17.2863 9.12688Z"
          fill="url(#paint1_linear_3526_87111)"
        />
        <path
          d="M20.1968 11.8117V0H22.6038V11.8117H20.1968Z"
          fill="url(#paint2_linear_3526_87111)"
        />
        <path
          d="M27.5173 4.61664C26.4622 4.61664 25.7038 5.41064 25.6214 6.5075H29.372C29.3225 5.38608 28.5889 4.61664 27.5173 4.61664ZM29.4049 9.12688H31.6141C31.3503 10.8458 29.7676 12 27.5832 12C24.863 12 23.2309 10.2729 23.2309 7.46521C23.2309 4.66576 24.8795 2.84857 27.4926 2.84857C30.0644 2.84857 31.6883 4.57572 31.6883 7.2442V7.97271H25.5967V8.12005C25.5967 9.37244 26.3962 10.2319 27.6244 10.2319C28.5065 10.2319 29.1824 9.79809 29.4049 9.12688Z"
          fill="url(#paint3_linear_3526_87111)"
        />
        <path
          d="M32.2577 11.8117V3.03683H34.5822V4.60027H34.6317C35.1016 3.5116 36.033 2.87312 37.3931 2.87312C39.355 2.87312 40.4595 4.10096 40.4595 6.15553V11.8117H38.0526V6.65484C38.0526 5.50887 37.5085 4.85402 36.4287 4.85402C35.3488 4.85402 34.6647 5.63984 34.6647 6.77763V11.8117H32.2577Z"
          fill="url(#paint4_linear_3526_87111)"
        />
        <path
          d="M44.7219 10.2237C45.7687 10.2237 46.6342 9.54434 46.6342 8.59482V7.95634L44.7713 8.07094C43.8728 8.13643 43.3618 8.53752 43.3618 9.15962C43.3618 9.81446 43.9058 10.2237 44.7219 10.2237ZM43.9305 11.9509C42.2489 11.9509 40.9713 10.8704 40.9713 9.29059C40.9713 7.69441 42.2077 6.76944 44.4086 6.63847L46.6342 6.5075V5.92633C46.6342 5.10778 46.0572 4.63302 45.1505 4.63302C44.252 4.63302 43.6832 5.07503 43.5678 5.72169H41.3669C41.4576 4.0191 42.9166 2.84857 45.2577 2.84857C47.5245 2.84857 49 4.01091 49 5.77899V11.8117H46.6755V10.4693H46.626C46.1314 11.4025 45.0351 11.9509 43.9305 11.9509Z"
          fill="url(#paint5_linear_3526_87111)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3526_87111"
            x1="-1.28042"
            y1="15.9771"
            x2="23.8804"
            y2="-11.8429"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FDBEDE" />
            <stop offset="0.463545" stop-color="#7B5AFF" />
            <stop offset="0.927091" stop-color="#4A25E1" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3526_87111"
            x1="-1.28042"
            y1="15.9771"
            x2="23.8804"
            y2="-11.8429"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FDBEDE" />
            <stop offset="0.463545" stop-color="#7B5AFF" />
            <stop offset="0.927091" stop-color="#4A25E1" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3526_87111"
            x1="-1.28042"
            y1="15.9771"
            x2="23.8804"
            y2="-11.8429"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FDBEDE" />
            <stop offset="0.463545" stop-color="#7B5AFF" />
            <stop offset="0.927091" stop-color="#4A25E1" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_3526_87111"
            x1="-1.28042"
            y1="15.9771"
            x2="23.8804"
            y2="-11.8429"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FDBEDE" />
            <stop offset="0.463545" stop-color="#7B5AFF" />
            <stop offset="0.927091" stop-color="#4A25E1" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_3526_87111"
            x1="-1.28042"
            y1="15.9771"
            x2="23.8804"
            y2="-11.8429"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FDBEDE" />
            <stop offset="0.463545" stop-color="#7B5AFF" />
            <stop offset="0.927091" stop-color="#4A25E1" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_3526_87111"
            x1="-1.28042"
            y1="15.9771"
            x2="23.8804"
            y2="-11.8429"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FDBEDE" />
            <stop offset="0.463545" stop-color="#7B5AFF" />
            <stop offset="0.927091" stop-color="#4A25E1" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
